const translations = {
    addFlight: 'Add Flight',
    flightTab: 'Flights',
    title: 'Select Flights',
    titleDescription: 'Selected flights will be added to the flight group.'
};

export default translations;
